import { viperApi, clinicalApiPath } from '@/services/viper-api'
import * as qs from 'qs'

export const trialIdentificationService = {
  basePath: organizationId =>
    `${clinicalApiPath}/organizations/${organizationId}/trialIdentifications`,

  getTrialIdentifications(orgId, trialId, params, cancelToken = null) {
    return viperApi.get(this.basePath(orgId) + `/${trialId}`, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' })
      },
      cancelToken
    })
  },

  getPatientTrialIdentification(orgId, trialId, patientId, params) {
    return viperApi.get(this.basePath(orgId) + `/${trialId}/patients/${patientId}`, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params)
      }
    })
  },

  getPatientTrialIdentifications(orgId, patientId, params) {
    return viperApi.get(this.basePath(orgId) + `/patients/${patientId}`, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params)
      }
    })
  },

  getIdentifiedTrialEligibility(orgId, trialId, caseId) {
    return viperApi.get(this.basePath(orgId) + `/${trialId}/${caseId}`)
  },

  /**
   *
   * @param orgId
   * @param trialId
   * @param params defined as { patientId : <patientId> }
   * @returns {never}
   */
  getIdentifiedTrialEligibilityDetails(orgId, trialId, params) {
    let parameters = { ...params, paged: true }
    return viperApi.get(this.basePath(orgId) + `/${trialId}/details`, {
      params: parameters,
      paramsSerializer: function(parameters) {
        return qs.stringify(parameters, { allowDots: true, arrayFormat: 'repeat' })
      }
    })
  },

  createTrialIdentificationsForPatient(orgId, patientId, trialIds) {
    const path = `${this.basePath(orgId)}/patients/${patientId}/manually-identify`
    return viperApi.post(path, { trialIds })
  }
}
